

export class MonthlySalaryBankFormatDto implements IMonthlySalaryBankFormatDto {
    bankTxtFormat!: string | undefined;
    groupRankId!: number;

    constructor(data?: IMonthlySalaryBankFormatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankTxtFormat = _data["bankTxtFormat"];
            this.groupRankId = _data["groupRankId"];
        }
    }

    static fromJS(data: any): MonthlySalaryBankFormatDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlySalaryBankFormatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankTxtFormat"] = this.bankTxtFormat;
        data["groupRankId"] = this.groupRankId;
        return data; 
    }
}

export interface IMonthlySalaryBankFormatDto {
    bankTxtFormat: string | undefined;
    groupRankId: number;
}

